export default "__VITE_ASSET__BkH5ntMi__"